<template>
  <div class="radio" @click="$emit('click')">
    <input class="radio-input" type="radio" :name="name" :checked="checked" />
    <span class="radio-checkmark"></span>
  </div>
</template>

<script>
export default {
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.radio {
  height: 16px;
  width: 16px;
  display: block;
  position: relative;
  cursor: pointer;

  &-input {
    position: absolute;
    opacity: 0;
    transition: all 200ms;

    &:checked {
      & ~ .radio-checkmark {
        background-color: var.$green-main;
        border-color: var.$green-main;
      }

      & ~ .radio-checkmark:after {
        display: block;
      }
    }
  }

  &-checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 16px;
    width: 16px;
    background-color: var.$white;
    border: 1px solid var.$gray-dark;
    border-radius: 50%;
    transition: all 200ms;

    &:after {
      content: "";
      position: absolute;
      display: none;

      top: 4.6px;
      left: 4.6px;
      width: 4.8px;
      height: 4.8px;
      border-radius: 50%;
      background: var.$white;
    }

    &:hover {
      background-color: var.$gray-light;
      border: 1px solid var.$gray-light;
    }
  }
}
</style>
